export const navbarLinks = [
  {
    to: '/',
    label: "Home"
  },
  {
    to: '/recipes/vegetarian',
    label: 'Vegetarianos'
  },
  {
    to: '/recipes/plates',
    label: 'Platos Principales'
  },
  {
    to: '/recipes/cakes',
    label: 'Tortas'
  },
  {
    to: '/recipes/fast-foot',
    label: 'Comida Rápida'
  },
  {
    to: '/recipes/kids',
    label: 'Menú Niños'
  },
  {
    to: '/recipes/soup',
    label: 'Sopas'
  },
]